
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIdTag as ObiIdTagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-id-tag.js';
 
 
 

 
 export const ObiIdTag = createComponent({
   react: React,
   tagName: 'obi-id-tag',
   elementClass: ObiIdTagElement,
   events: {
     
   }
  });
 
 